import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Button,
  Container,
  Drawer,
  IconButton,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Link as RouterLink } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const Navigation = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { label: 'Home', path: '/' },
    { label: 'About Us', path: '/about' },
    { label: 'Services', path: '/services' },
    { label: 'Events', path: '/events' },
    { label: 'Contact', path: '/contact' },
    { label: 'Donate', path: '/get-involved', highlight: true },
  ];

  const drawer = (
    <Box sx={{ width: 250 }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
        <IconButton onClick={() => setMobileOpen(false)}>
          <CloseIcon />
        </IconButton>
      </Box>
      <List>
        {navItems.map((item) => (
          <ListItem key={item.path} disablePadding>
            <ListItemButton
              component={RouterLink}
              to={item.path}
              onClick={() => setMobileOpen(false)}
              selected={location.pathname === item.path}
              sx={
                item.highlight
                  ? {
                      backgroundColor: 'rgba(208,151,4,0.18)',
                      '&:hover': { backgroundColor: 'rgba(208,151,4,0.28)' },
                    }
                  : undefined
              }
            >
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar position="sticky" sx={{ background: 'linear-gradient(135deg, #2E5090 0%, #1B3057 100%)', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <Toolbar component={Container} maxWidth="lg" sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <RouterLink to="/" style={{ textDecoration: 'none', color: 'white' }}>
            <Box
              component="img"
              src="/topNavLogo.png"
              alt="Dharmamma Charitable Trust"
              sx={{
                display: 'block',
                height: { xs: 36, md: 44 },
                width: 'auto',
                borderRadius: '10px',
                border: '1.4px solid #D09704',
                background: '#1B3057',
              }}
            />
          </RouterLink>

          {/* Desktop Navigation */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1 }}>
            {navItems.map((item) => (
              <Button
                key={item.path}
                component={RouterLink}
                to={item.path}
                color="inherit"
                sx={{
                  position: 'relative',
                  ...(item.highlight
                    ? {
                        backgroundColor: '#D09704',
                        color: '#1B3057',
                        fontWeight: 700,
                        borderRadius: 999,
                        px: 2.5,
                        '&:hover': { backgroundColor: '#B07A00' },
                        '&::after': { display: 'none' },
                      }
                    : {}),
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: location.pathname === item.path ? '100%' : '0%',
                    height: '3px',
                    backgroundColor: '#D09704',
                    transition: 'width 0.3s ease',
                  },
                  '&:hover::after': {
                    width: '100%',
                  },
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>

          {/* Mobile Menu Button */}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={() => setMobileOpen(!mobileOpen)}
            sx={{ display: { xs: 'flex', md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer anchor="right" open={mobileOpen} onClose={() => setMobileOpen(false)}>
        {drawer}
      </Drawer>
    </>
  );
};

export default Navigation;
